export function scrollX() {
  return null != window.scrollX
    ? window.scrollX
    : null != window.pageXOffset
    ? window.pageXOffset
    : (document.documentElement || document.body.parentNode || document.body).scrollLeft
}

export function scrollY() {
  return null != window.scrollY
    ? window.scrollY
    : null != window.pageYOffset
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body).scrollTop
}
